export default "__VITE_ASSET__BLW55ND8__"